@if (teamMember) {
  <div class="box">
    <div class="box-header teamMemberExpender" (click)="cancelForm()">
      <h3>
      <img alt="close" class="accordion-icon" id="accordian-id1" [src]="teamMember.expanded ? 'assets/images/circled-cross.svg' :
            'assets/images/circled-plus-black.svg'">{{this.displayHeader | translate}}
        </h3>
      </div>
      <div class="box-body">
        <div class="sub-text">{{ (soseMode ? 'ApplicationForNewSoseRecognition.ApplicantInformation.AddAlternateContactLeadText' : 'RegisterasTrainingProvider.YouCanAppoint') | translate}}</div>
        @if (teamMember.expanded) {
          <form [formGroup]="newTeamMemberForm">
            @if (soseMode) {
              <!-- Last Name -->
              <div class="ontario-row">
                <div class="signing-authority-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                  <mat-label class="input-label">
                    <span class="required-field">{{'Contact.LastName' | translate}}</span>
                  </mat-label>
                  <input type="text" class='input-text' matInput formControlName="lastName" required
                    placeholder="{{'Contact.LastNameTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (newTeamMemberForm.controls['lastName'].invalid &&  newTeamMemberForm.controls['lastName'].errors &&
                    (newTeamMemberForm.controls['lastName'].dirty || newTeamMemberForm.controls['lastName'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (newTeamMemberForm.controls['lastName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.LastName.Required' | translate}}
                        </mat-error>
                      }
                      @if (newTeamMemberForm.controls['lastName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.LastName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <!-- First Name -->
                <div class="ontario-row">
                  <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label">
                      <span class="required-field">{{'Contact.FirstName' | translate}}</span>
                    </mat-label>
                    <input type="text" class='input-text' matInput formControlName="firstName" required
                      placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                    </div>
                    @if (showErrorsOverride || (newTeamMemberForm.controls['firstName'].invalid &&  newTeamMemberForm.controls['firstName'].errors &&
                      (newTeamMemberForm.controls['firstName'].dirty || newTeamMemberForm.controls['firstName'].touched))) {
                      <div class="form-field-error ontario-column ontario-small-12"
                        >
                        @if (newTeamMemberForm.controls['firstName'].hasError('required')) {
                          <mat-error>
                            {{'Validation.FirstName.Required' | translate}}
                          </mat-error>
                        }
                        @if (newTeamMemberForm.controls['firstName'].hasError('maxlength')) {
                          <mat-error>
                            {{'Validation.FirstName.MaxLength' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                  <!-- Middle Initial -->
                  <div class="ontario-row">
                    <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                      <mat-label class="input-label">{{'Contact.MiddleInitial' | translate}}
                      </mat-label>
                      <input type="text" class='input-text' matInput formControlName="middleInitial"
                        placeholder="{{'Contact.MiddleInitialTooltip' | translate}}" maxlength="256" />
                      </div>
                      @if (showErrorsOverride || (newTeamMemberForm.controls['middleInitial'].invalid &&  newTeamMemberForm.controls['middleInitial'].errors &&
                        (newTeamMemberForm.controls['middleInitial'].dirty || newTeamMemberForm.controls['middleInitial'].touched))) {
                        <div class="form-field-error ontario-column ontario-small-12"
                          >
                        </div>
                      }
                    </div>
                    <!-- Position -->
                    <div class="ontario-row">
                      <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                        <mat-label class="input-label"><span class="required-field first-required">{{'Contact.Position' | translate}}</span>
                      </mat-label>
                      <input type="text" class='input-text' matInput formControlName="position"
                        placeholder="{{'Contact.PositionTooltip' | translate}}" maxlength="256" />
                      </div>
                      @if (showErrorsOverride || (newTeamMemberForm.controls['position'].invalid &&  newTeamMemberForm.controls['position'].errors &&
                        (newTeamMemberForm.controls['position'].dirty || newTeamMemberForm.controls['position'].touched))) {
                        <div class="form-field-error ontario-column ontario-small-12"
                          >
                          @if (newTeamMemberForm.controls['position'].hasError('required')) {
                            <mat-error>
                              {{'Validation.Position.Required' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                    <!-- Email -->
                    <div class="ontario-row">
                      <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                        <mat-label class="input-label">
                          <span class="required-field">{{'Contact.EmailAddress'|translate}}</span>
                        </mat-label>
                        <input type="text" class='input-text' matInput formControlName="emailAddress" required
                          placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                        </div>
                        @if (showErrorsOverride || (newTeamMemberForm.controls['emailAddress'].invalid && newTeamMemberForm.controls['emailAddress'].errors &&
                          (newTeamMemberForm.controls['emailAddress'].dirty || newTeamMemberForm.controls['emailAddress'].touched))) {
                          <div class="form-field-error ontario-column ontario-small-12"
                            >
                            @if (newTeamMemberForm.controls['emailAddress'].hasError('pattern')) {
                              <mat-error>
                                {{'Validation.Email.Pattern' | translate}}
                              </mat-error>
                            }
                            @if (newTeamMemberForm.controls['emailAddress'].hasError('required')) {
                              <mat-error>
                                {{'Validation.Email.PoliteRequired' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                      <!-- Phone -->
                      <div class="ontario-row">
                        <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                          <mat-label class="input-label">
                            <span class="required-field">{{'Contact.Phone' | translate}}</span>
                          </mat-label>
                          <input type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone"
                            placeholder="{{'Contact.PhoneTooltip' | translate}}" required />
                          </div>
                          @if (showErrorsOverride || (newTeamMemberForm.controls['phone'].invalid &&  newTeamMemberForm.controls['phone'].errors &&
                            (newTeamMemberForm.controls['phone'].dirty || newTeamMemberForm.controls['phone'].touched))) {
                            <div class="form-field-error ontario-column ontario-small-12">
                              @if (newTeamMemberForm.controls['phone'].hasError('required')) {
                                <mat-error>
                                  {{'Validation.Phone.PoliteRequired' | translate}}
                                </mat-error>
                              }
                              @if (newTeamMemberForm.controls['phone'].hasError('maxlength')) {
                                <mat-error>
                                  {{'Validation.Phone.MaxLength' | translate}}
                                </mat-error>
                              }
                              @if (newTeamMemberForm.controls['phone'].hasError('pattern')) {
                                <mat-error>
                                  {{'Validation.Phone.Pattern' | translate}}
                                </mat-error>
                              }
                            </div>
                          }
                        </div>
                      } @else {
                        <div class="ontario-row">
                          <div class="signing-authority-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                            <mat-label class="input-label">
                              <span class="required-field">{{'Contact.FirstName' | translate}}</span>
                            </mat-label>
                            <input type="text" class='input-text' matInput formControlName="firstName" required
                              placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                            </div>
                            @if (showErrorsOverride || (newTeamMemberForm.controls['firstName'].invalid &&  newTeamMemberForm.controls['firstName'].errors &&
                              (newTeamMemberForm.controls['firstName'].dirty || newTeamMemberForm.controls['firstName'].touched))) {
                              <div class="form-field-error ontario-column ontario-small-12"
                                >
                                @if (newTeamMemberForm.controls['firstName'].hasError('required')) {
                                  <mat-error>
                                    {{'Validation.FirstName.Required' | translate}}
                                  </mat-error>
                                }
                                @if (newTeamMemberForm.controls['firstName'].hasError('maxlength')) {
                                  <mat-error>
                                    {{'Validation.FirstName.MaxLength' | translate}}
                                  </mat-error>
                                }
                              </div>
                            }
                          </div>
                          <div class="ontario-row">
                            <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                              <mat-label class="input-label">
                                <span class="required-field">{{'Contact.LastName' | translate}}</span>
                              </mat-label>
                              <input type="text" class='input-text' matInput formControlName="lastName" required
                                placeholder="{{'Contact.LastNameTooltip' | translate}}" />
                              </div>
                              @if (showErrorsOverride || (newTeamMemberForm.controls['lastName'].invalid &&  newTeamMemberForm.controls['lastName'].errors &&
                                (newTeamMemberForm.controls['lastName'].dirty || newTeamMemberForm.controls['lastName'].touched))) {
                                <div class="form-field-error ontario-column ontario-small-12"
                                  >
                                  @if (newTeamMemberForm.controls['lastName'].hasError('required')) {
                                    <mat-error>
                                      {{'Validation.LastName.Required' | translate}}
                                    </mat-error>
                                  }
                                  @if (newTeamMemberForm.controls['lastName'].hasError('maxlength')) {
                                    <mat-error>
                                      {{'Validation.LastName.MaxLength' | translate}}
                                    </mat-error>
                                  }
                                </div>
                              }
                            </div>
                            <div class="ontario-row">
                              <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                                <mat-label class="input-label">
                                  {{'Contact.Phone' | translate}}
                                </mat-label>
                                <input type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone"
                                  placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                                </div>
                                @if (showErrorsOverride || (newTeamMemberForm.controls['phone'].invalid &&  newTeamMemberForm.controls['phone'].errors &&
                                  (newTeamMemberForm.controls['phone'].dirty || newTeamMemberForm.controls['phone'].touched))) {
                                  <div class="form-field-error ontario-column ontario-small-12">
                                    @if (newTeamMemberForm.controls['phone'].hasError('maxlength')) {
                                      <mat-error>
                                        {{'Validation.Phone.MaxLength' | translate}}
                                      </mat-error>
                                    }
                                    @if (newTeamMemberForm.controls['phone'].hasError('pattern')) {
                                      <mat-error>
                                        {{'Validation.Phone.Pattern' | translate}}
                                      </mat-error>
                                    }
                                  </div>
                                }
                              </div>
                              <div class="ontario-row">
                                <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                                  <mat-label class="input-label">
                                    <span class="required-field">
                                      {{'Contact.EmailAddress' | translate}}
                                    </span>
                                    <app-tooltip [tooltipText]="'RegisterasTrainingProvider.EmailTooltip' | translate">
                                    </app-tooltip>
                                  </mat-label>
                                  <input type="text" class='input-text' matInput formControlName="emailAddress" required
                                    placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                                  </div>
                                  @if (showErrorsOverride || (newTeamMemberForm.controls['emailAddress'].invalid &&  newTeamMemberForm.controls['emailAddress'].errors &&
                                    (newTeamMemberForm.controls['emailAddress'].dirty || newTeamMemberForm.controls['emailAddress'].touched))) {
                                    <div class="form-field-error ontario-column ontario-small-12"
                                      >
                                      @if (newTeamMemberForm.controls['emailAddress'].hasError('pattern')) {
                                        <mat-error>
                                          {{'Validation.Email.Pattern' | translate}}
                                        </mat-error>
                                      }
                                      @if (newTeamMemberForm.controls['emailAddress'].hasError('required')) {
                                        <mat-error>
                                          {{'Validation.Email.PoliteRequired' | translate}}
                                        </mat-error>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="ontario-row">
                                  <div class="signing-authority-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5 required-col has-tooltip">
                                    <app-dropdown [label]="'RegisterasTrainingProvider.RoleInOrganization' | translate"
                                      [placeholder]="('Contact.SelectAnAccountType' | translate)"
                                      [tooltipText]="'RegisterasTrainingProvider.RoleInOrganizationTooltip' | translate"
                                      [currentLang]="currentLang" [options]="roleInOrganizationOptions" [(formValue)]="role"
                                      (formValueChange)="newTeamMemberForm.controls['role'].setValue(role)">
                                    </app-dropdown>
                                  </div>
                                  @if (showErrorsOverride || (newTeamMemberForm.controls['role'].invalid &&  newTeamMemberForm.controls['role'].errors &&
                                    (newTeamMemberForm.controls['role'].dirty || newTeamMemberForm.controls['role'].touched))) {
                                    <div class="form-field-error ontario-column ontario-small-12">
                                      @if (newTeamMemberForm.controls['role'].hasError('required') || newTeamMemberForm.controls['role'].value == null ||
                                        newTeamMemberForm.controls['role'].value == '' || newTeamMemberForm.controls['role'].value == undefined) {
                                        <mat-error>
                                          {{'SigningAuthorityInformation.Validation.RoleInOrganization.Required' | translate}}
                                        </mat-error>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              <hr class="border">
                              <button id="cancel" (click)="cancelForm()">
                                {{'General.Cancel' | translate}}
                              </button>
                            </form>
                          }
                        </div>
                      </div>
                    }
